import ViewMaintenanceItem from "../common/view-maintenance-item";

export default function ViewTemplateMaintenanceItem() {
  return <ViewMaintenanceItem />;
}
